import {Button, Card, CardBody, CardFooter, CardHeader, Heading} from "grommet";
import React from "react";
import {Container} from "@mui/material";

const CardHome=(props)=>{
    return(
        <Card background="#fdfdfd" width="300px" boxShadow="0px 0px black" margin="small" height="300px">
            <CardHeader pad="medium" alignSelf="center"><Heading level="3" margin="xsmall">{props?.name}</Heading></CardHeader>
            <CardBody pad="medium" alignSelf="center"><Button icon={props?.icon} onClick={props?.onClick}/></CardBody>
            <CardFooter pad={{horizontal: "small"}} background="brad">
            </CardFooter>
        </Card>
    )
}

export default CardHome;